import { memo } from 'react';
import { BoxProps } from '@shopify/polaris';
import { useBannerState } from '@/hooks/useBannerState';
import { SessionBanner } from '@/types/banners';
import BasicBanner, { BannerProps } from './BasicBanner';

export type DismissibleBannerProps = BannerProps & {
  sessionBanner: SessionBanner;
  failedAssetId?: string;
  showBanner?: boolean;
  boxComponentProps?: BoxProps;
};

const DismissibleBanner: React.FC<DismissibleBannerProps> = ({
  sessionBanner,
  failedAssetId,
  showBanner,
  children,
  boxComponentProps,
  ...bannerProps
}) => {
  const { useUpdateBannerState, useIsBannerHidden } = useBannerState(sessionBanner);
  const updateBannerState = useUpdateBannerState(false);
  const { data: isBannerHidden, isLoading } = useIsBannerHidden();

  const handleDismiss = async () => {
    updateBannerState.mutateAsync();
  };

  return (
    <BasicBanner
      isLoading={isLoading}
      hidden={isBannerHidden || !showBanner}
      boxComponentProps={boxComponentProps}
      onDismiss={handleDismiss}
      {...bannerProps}
    >
      {children}
    </BasicBanner>
  );
};

export default memo(DismissibleBanner);
